/* eslint max-classes-per-file: 0 */

import { AxiosRequestConfig } from 'axios'
import {
  Roadmap as Data,
  RoadmapCollection as Collection,
} from '@/typings/api/Roadmap'
import { RegionCollection } from '@/typings/api/Region'
import { MunicipalityCollection } from '@/typings/api/Municipality'
import { SchoolCollection } from '@/typings/api/School'
import {
  BaseApiResponse as BR,
  BaseApiResponseCollection as BRC,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class RoadmapsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/roadmaps';
}

export class RoadmapsFeedApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/roadmaps/feed';

  public getYears(
    config: AxiosRequestConfig = {},
  ) {
    const path = 'years/'
    const [url] = this.getUrl(path)
    return this.request<never, BRC<Array<number>>>('GET', url, { ...config })
  }

  public getRegions(
    params: Record<string, unknown>,
    config: AxiosRequestConfig = {},
  ) {
    const path = 'regions/'
    const [url] = this.getUrl(path)
    return this.request<never, BRC<RegionCollection>>('GET', url, { params, ...config })
  }

  public getMunicipalities(
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = 'municipalities/'
    const [url] = this.getUrl(path, params)
    return this.request<never, BRC<MunicipalityCollection>>('GET', url, { params, ...config })
  }

  public getSchools(
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = 'schools/'
    const [url] = this.getUrl(path, params)
    return this.request<never, BRC<SchoolCollection>>('GET', url, { params, ...config })
  }

  public getRoadmaps(
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = '/'
    const [url] = this.getUrl(path, params)
    return this.request<never, BRC<Collection>>('GET', url, { params, ...config })
  }

  public getRoadmap(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/`
    const [url] = this.getUrl(path, params)
    return this.request<never, BR<Data>>('GET', url, { params, ...config })
  }

  public getCount(
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = 'count/'
    const [url] = this.getUrl(path, params)
    return this.request<never, BR<{ roadmaps_count: number }>>('GET', url, { params, ...config })
  }
}
